import { rgba } from 'polished';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { cFFFFFF } from '#/colors';

interface Props {
  label: ReactNode;
  value: ReactNode;
  className?: string;
}

export default function Indicator(props: Props) {
  const { label, value, className } = props;

  return (
    <div className={className}>
      <Label>{label}</Label>
      <Value>{value}</Value>
    </div>
  );
}

const Label = styled.div`
  display: block;
  padding-bottom: 8px;
  font-size: 11px;
  line-height: 11px;
  color: ${rgba(cFFFFFF, 0.5)};
`;

const Value = styled.div`
  font-size: 12px;
  line-height: 12px;
  color: ${rgba(cFFFFFF, 0.7)};
`;
